import api from "@/utils/api";

export const state = {
  _users: [],
  _usersTotal: 0,
  _billings: [],
  _logs: [],
  _logsTotal: 0,
};

export const mutations = {
  setUsers(state, { users, total }) {
    state._users = users;
    state._usersTotal = total;
  },
  setBillings(state, items) {
    state._billings = items;
  },
  setLogs(state, { items, total }) {
    state._logs = items;
    state._logsTotal = total;
  },
};

export const actions = {
  // 이메일/전화번호로 유저 검색
  async acSearchUsers({ commit }, { q, page = 1, size = 20 }) {
    try {
      const res = await api.get("/api/v1/manual-payment/users", {
        params: { q, page, size },
      });
      if (res.data?.code === 0) {
        commit("setUsers", {
          users: res.data.users || [],
          total: res.data.total || 0,
        });
        return { success: true };
      }
      return { success: false, message: res.data?.message || "검색 실패" };
    } catch (error) {
      console.error("[manual-payment] search error:", error);
      return {
        success: false,
        message: error?.data?.message || "서버 오류",
      };
    }
  },

  // 유저의 사용중 빌링키 목록
  async acListBillings({ commit }, { userNo }) {
    try {
      const res = await api.get(
        `/api/v1/manual-payment/users/${userNo}/billings`,
      );
      if (res.data?.code === 0) {
        commit("setBillings", res.data.items || []);
        return { success: true, items: res.data.items || [] };
      }
      return { success: false, message: res.data?.message || "조회 실패" };
    } catch (error) {
      console.error("[manual-payment] billings error:", error);
      return {
        success: false,
        message: error?.data?.message || "서버 오류",
      };
    }
  },

  // 결제 실행
  // payload: { user_no, billing_seq, amount, reason_category, reason_text? }
  // 서버 AuthAdminGuard가 req.body.user_no를 관리자 user_no로 덮어쓰므로,
  // 결제 대상 유저는 target_user_no 필드로 보내야 함.
  async acCreatePayment(_, payload) {
    try {
      const body = {
        target_user_no: payload.user_no,
        billing_seq: payload.billing_seq,
        amount: payload.amount,
        reason_category: payload.reason_category,
        reason_text: payload.reason_text,
      };
      const res = await api.post("/api/v1/manual-payment", body);
      // BE는 성공/실패 모두 HTTP 200 + body.success 로 구분
      return {
        success: !!res.data?.success,
        data: res.data,
        message: res.data?.message,
      };
    } catch (error) {
      // HTTP 429 (따닥방지), 400 (검증 실패), 404 (빌링키 없음) 등
      const status = error?.status;
      const data = error?.data;
      if (status === 429) {
        return {
          success: false,
          duplicated: true,
          message:
            data?.message || "최근 동일 요청이 있었습니다. 잠시 후 다시 시도해주세요.",
        };
      }
      return {
        success: false,
        message: data?.message || "결제 요청 실패",
      };
    }
  },

  // 결제 로그 리스트
  async acListLogs({ commit }, filter) {
    try {
      const params = {};
      if (filter.from) params.from = filter.from;
      if (filter.to) params.to = filter.to;
      if (filter.admin_no) params.admin_no = filter.admin_no;
      if (filter.status) params.status = filter.status;
      params.page = filter.page || 1;
      params.size = filter.size || 20;
      const res = await api.get("/api/v1/manual-payment", { params });
      if (res.data?.code === 0) {
        commit("setLogs", {
          items: res.data.items || [],
          total: res.data.total || 0,
        });
        return { success: true };
      }
      return { success: false, message: res.data?.message || "조회 실패" };
    } catch (error) {
      console.error("[manual-payment] logs error:", error);
      return {
        success: false,
        message: error?.data?.message || "서버 오류",
      };
    }
  },

  // 상세 (pg_response 포함)
  async acDetail(_, { seq }) {
    try {
      const res = await api.get(`/api/v1/manual-payment/${seq}`);
      if (res.data?.code === 0) {
        return { success: true, item: res.data.item };
      }
      return { success: false, message: res.data?.message || "조회 실패" };
    } catch (error) {
      return {
        success: false,
        message: error?.data?.message || "서버 오류",
      };
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
